//organizes dataItems into rows based on DisplayMode
import {DataItem, DisplayMode} from "@/models/general";
import {maxInfographicsPerRow} from "@/consts/consts";

export function organizeIntoRows(dataItems: DataItem[]): Array<DataItem[]> {
    const rows: Array<DataItem[]> = []

    if (dataItems) {

        dataItems.forEach(i => {
            if (i.displayMode === DisplayMode.FullRow) {
                rows.push([i])  //if fullrow, take up new row
            } else {
                let lastRow = rows[rows.length - 1]
                if (lastRow && !isRowFull(lastRow)) {
                    lastRow.push(i)  // if there is a last row, and there is space for one more, and the last row does not contain a 'fullrow' item,  join it
                } else {
                    rows.push([i]) // if conditions above not met, then create a new row with the current item
                }
            }

        })
    }
    return rows;
}

export function isRowFull(row: DataItem[]){
   return row.length >= maxInfographicsPerRow || row.some(el => el.displayMode === DisplayMode.FullRow)
}

